import MobileNavBar from "../MobileNavBar/MobileNavBar";
import { useEffect } from "react";
import "./Pages.css";

export default function LicensePage({
  onBurgerClick,
  onBurgerClose,
  isBurgerOpen,
  orders,
  cart,
  onCatClick,
  isLoggedIn,
}) {
  useEffect(() => {
    document.title = "Политика обработки данных — Долина самоцветов";
  }, []);

  return (
    <>
      <main className="license">
        <a href=""></a>
        <h3>Текст соглашения на обработку персональных данных </h3>
        <p>
          Настоящим в соответствии с Федеральным законом № 152-ФЗ «О
          персональных данных» от 27.07.2006 года Вы подтверждаете свое согласие
          на обработку компанией Долина самоцветов персональных данных: сбор,
          систематизацию, накопление, хранение, уточнение (обновление,
          изменение), использование, передачу исключительно в целях продажи
          программного обеспечения на Ваше имя, как это описано ниже,
          блокирование, обезличивание, уничтожение.
        </p>
        <p className="">
          Компания Долина самоцветов гарантирует конфиденциальность получаемой
          информации. Обработка персональных данных осуществляется в целях
          эффективного исполнения заказов, договоров и иных обязательств,
          принятых компанией Долина самоцветов в качестве обязательных к
          исполнению.
        </p>
        <p className="">
          В случае необходимости предоставления Ваших персональных данных
          правообладателю, дистрибьютору или реселлеру программного обеспечения
          в целях регистрации программного обеспечения на ваше имя, вы даёте
          согласие на передачу ваших персональных данных. Компания Долина
          самоцветов гарантирует, что правообладатель, дистрибьютор или реселлер
          программного обеспечения осуществляет защиту персональных данных на
          условиях, аналогичных изложенным в Политике конфиденциальности
          персональных данных.
        </p>

        <p className="">
          Настоящее согласие распространяется на следующие Ваши персональные
          данные: фамилия, имя и отчество, адрес электронной почты, почтовый
          адрес доставки заказов, контактный телефон, платёжные реквизиты. Срок
          действия согласия является неограниченным. Вы можете в любой момент
          отозвать настоящее согласие, направив электронное уведомления на
          адрес: info@dolina.shop с пометкой «Отзыв согласия на обработку
          персональных данных». Обращаем ваше внимание, что отзыв согласия на
          обработку персональных данных влечёт за собой удаление Вашей учётной
          записи с Интернет-сайта (<a href="">https://dolina.shop</a>), а также
          уничтожение записей, содержащих ваши персональные данные, в системах
          обработки персональных данных компании Долина самоцветов, что может
          сделать невозможным пользование интернет-сервисами компании Долина
          самоцветов.
        </p>
        <p className="">
          Гарантирую, что представленная мной информация является полной, точной
          и достоверной, а также что при представлении информации не нарушаются
          действующее законодательство Российской Федерации, законные права и
          интересы третьих лиц. Вся представленная информация заполнена мною в
          отношении себя лично. Настоящее согласие действует в течение всего
          периода хранения персональных данных, если иное не предусмотрено
          законодательством Российской Федерации.
        </p>
      </main>
      <MobileNavBar
        onBurger={onBurgerClick}
        isBurgerOpen={isBurgerOpen}
        onBurgerClose={onBurgerClose}
        cart={cart}
        onCatClick={onCatClick}
        orders={orders}
        isLoggedIn={isLoggedIn}
      />
    </>
  );
}
